/* src/app/forms/produtos/produto-kit/produto-kit.component.scss */
:host {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  padding: 10px;
}
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
}
.mat-mdc-form-field {
  width: 100%;
  height: 100%;
}
.content > * {
  width: 100%;
}
.full {
  width: 100% !important;
}
.data-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
}
mat-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
mat-card-content {
  height: 100%;
}
/*# sourceMappingURL=produto-kit.component.css.map */
